import { Box, useDisclosure } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";
import { ButtonLink } from "src/components/base/button";
import { IconArrowRight } from "src/components/icons";
import { TUserReactions } from "src/components/user-reactions/types";
import { AllTraderReactionsModal } from "./all-trader-reactions-modal";

interface IAllTraderReactions {
    reactions: TUserReactions;
    hasAnyTraderAnsweredUnderlyingPricePredictionQuestion: boolean;
    slug: string;
}

const ALL_TRADER_REACTIONS_VIEW_ALL_BUTTON_TEST_ID = "all-trader-reactions-view-all-button";

export const AllTraderReactions = ({ reactions, hasAnyTraderAnsweredUnderlyingPricePredictionQuestion, slug }: IAllTraderReactions) => {
    const { t } = useTranslation("news");
    const modalProps = useDisclosure();

    const reactionsWithUnderlyingIsin = reactions.filter(reaction => Boolean(reaction.underlyingIsin));
    const showContent = reactionsWithUnderlyingIsin.length > 0 && hasAnyTraderAnsweredUnderlyingPricePredictionQuestion;

    return showContent ? (
        <Box w="100%" textAlign={["left", "right"]} mt={2}>
            <ButtonLink onClick={modalProps.onToggle} data-test-id={ALL_TRADER_REACTIONS_VIEW_ALL_BUTTON_TEST_ID}>
                {t("buttons.view-all-traders-reactions")}
                <IconArrowRight ml={0.5} />
            </ButtonLink>
            <AllTraderReactionsModal reactionsWithUnderlyingIsin={reactionsWithUnderlyingIsin} slug={slug} modalProps={modalProps} />
        </Box>
    ) : null;
};
